import {Pipe, PipeTransform} from '@angular/core';

type SnackbarType = 'newTaskAssigned' | 'taskTriggered' | 'taskCompleted' | 'error';

@Pipe({
  name: 'snackbarIconName',
  standalone: true,
})
export class SnackbarIconNamePipe implements PipeTransform {
  transform(type: SnackbarType): string {
    switch (type) {
      case 'newTaskAssigned':
        return 'alert-star';
      case 'taskTriggered':
        return 'alert-bolt';
      case 'taskCompleted':
        return 'alert-check';
      case 'error':
        return 'alert-warning';
      default:
        return 'alert-warning';
    }
  }
}
